import React from 'react';
import ValidationSection from '../../../sections/AdminDashboard/Configuration/Validation';

const Validation = () => {
  return <ValidationSection />;
};

export default Validation;
